export default __webpack_public_path__ + "static/media/linkOutBlack.644560e0.svg";